import { render } from "./ModalConfirmation.vue?vue&type=template&id=6980fd5f&scoped=true"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js"

import "./ModalConfirmation.vue?vue&type=style&index=0&id=6980fd5f&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6980fd5f"]])

export default __exports__